// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'folder-hierarchy';

export const Component = () => (
  <>
    <path
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M17.428 4.956c0-.662-.507-1.177-1.158-1.177H7.806L6.504 2.015c-.217-.294-.578-.515-.94-.515H1.585C1.006 1.5.5 2.015.5 2.676v12.647c0 .662.506 1.177 1.157 1.177h14.686c.65 0 1.157-.515 1.157-1.177l-.072-10.367Z'
    />
    <path
      fill='currentColor'
      d='M11.175 8h-4.34c-.28 0-.42.193-.28.387l2.17 3.478c.14.13.35.194.49.065.07 0 .07-.065.07-.065l2.17-3.478c.14-.194-.07-.387-.28-.387Z'
    />
  </>
);

export const viewBox = '0 0 18 18';
